module.exports = __webpack_public_path__ + "static/media/06_tearsofhair.9ed52cac.jpg";